<template>
  <div class="col-md-8 col-lg-8 offset-md-2 offset-lg-2 page">
    <div class="cpt__list">
      <h1 class="list__header mt-md-0 mt-0">CPT ASSIGNMENTS</h1>
      <div class="gridarea">
        <div class="container">
          <div class="columntop">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
              <span id="col1" class="coltext">Code</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
              <span id="col2" class="coltext">Description</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
              <span id="col3" class="coltext">Frequency</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
              <span id="col4" class="coltext">Meter(s)</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col5" class="coltext">Current Cycle Start</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col6" class="coltext">Current Cycle End</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7" class="coltext">Current Cycle Count</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
              <span id="col8" class="coltext">Status</span>
            </div>
          </div>
          <template v-for="(cpt, key, index) in cptInfo">
            <div
              class="columnrow"
              :key="key + index"
              data-bs-toggle="collapse"
              :href="'#cptInfo' + key"
              aria-expanded="false"
              :aria-controls="'cptInfo' + key"
              role="button"
            >
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                <span id="cptCode" class="coltext">{{ key }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device">
                <span id="cptDesc" class="coltext">{{ cpt.desc }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                <span id="cptFreq" class="coltext">{{ cpt.timeframe }}</span>
              </div>
              <div
                class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device meterListColumn"
              >
                <div v-if="currentMeters.length != 0" class="meterList">
                  <span
                    v-for="meter in assignedMeters[key]"
                    :id="'meterList' + meter['0'] + meter['1']"
                    :key="'test' + meter['0'] + meter['1']"
                    class="coltext"
                  >
                    {{ meter.meter + (meter.meterName ? ` (${meter.meterName})` : "") }}
                  </span>
                </div>
                <span id="meterOptions" class="coltext">
                  <select
                    @change.stop="addingNewMeter(key)"
                    v-model="addedMeter[key]"
                    :id="'addedMeter' + key + index"
                  >
                    <option selected :value="0">Add Meter</option>
                    <option
                      v-for="meter in availableMeters(key)"
                      :key="meter.MeterID._text + 'cpt' + key"
                      :value="meter"
                    >
                      {{ meter.MeterID._text + " (" + meter.MeterName._cdata + ")" }}
                    </option>
                  </select>
                </span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                <span id="cycleStart" class="coltext">{{
                  currentData[key] ? currentData[key].firstDate : "N/A"
                }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                <span id="cycleEnd" class="coltext">{{
                  currentData[key] ? currentData[key].lastDate : "N/A"
                }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                <span id="cycleCount" class="coltext">{{
                  currentData[key]
                    ? formatCycleCount(key, currentData[key].cycleCount)
                    : "N/A"
                }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                <span id="cycleStatus" class="coltext">{{
                  currentData[key]
                    ? { 0: "Not Billable", 1: "Billable", 2: "Billed" }[
                        currentData[key].status
                      ]
                    : "N/A"
                }}</span>
              </div>
            </div>
            <div class="collapse" :id="'cptInfo' + key" :key="'cptInfo' + key">
              <div class="card card-body">
                <cpt-desc
                  :cpt="key"
                  :currentInfo="currentData[key]"
                  :historicalInfo="getHistoricalData(key)"
                  :measurements="getCptMeas(key)"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import cptInfo from "@/data/cptInfo";
import { xml2js } from "xml-js";
import CptDesc from "../private-layouts/CptDesc.vue";

export default {
  name: "cpt",
  components: {
    "cpt-desc": CptDesc,
  },
  data() {
    return {
      cptInfo,
      addedMeter: {
        99453: 0,
        99454: 0,
        99457: 0,
        99458: 0,
        98975: 0,
        98976: 0,
        98980: 0,
        98981: 0,
        99091: 0,
      },
      currentMeters: [],
      assignedMeters: {
        99453: [],
        99454: [],
        99457: [],
        99458: [],
        98975: [],
        98976: [],
        98980: [],
        98981: [],
        99091: [],
      },
      currentData: {},
      historicalData: {},
      measurements: [],
    };
  },
  mounted() {
    // Check db if cptCodes exists for patient, if not then make one
    this.getDevices();
    this.getAddedMeters();
    this.getCptData();
    this.getMeasurements();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
  },
  methods: {
    fmtMSS(s) {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    },
    formatCycleCount(cpt, count) {
      let append = " unique daily recordings";
      if (cpt === "98980" || cpt === "98981" || cpt === "99457" || cpt === "99458") {
        append = " minutes";
        return `${this.fmtMSS(count)} ${append}`;
      }
      return `${count} ${append}`;
    },
    async getMeasurements() {
      let content = {
        PatientCpt: {
          API_Meth: "GetMeasurements2",
          pid:
            ("" + this.allData.patient.externId).length == 7
              ? "0" + this.allData.patient.externId
              : "" + this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.measurements = res.data.data;
        });
    },
    getCptMeas(cpt) {
      if (this.measurements.length != 0) {
        let meters = this.assignedMeters[cpt].map((m) => m.meter);
        let answer = this.measurements.filter((meas) => meters.includes(meas.MDeviceID));
        return answer;
      }
      return [];
    },
    getHistoricalData(key) {
      let data = this.historicalData[key];
      if (data) {
        let current = this.currentData[key];
        data[current.fid] = current;
      }
      return data;
    },
    async getCptData() {
      let content = {
        PatientCpt: {
          API_Meth: "GetPatientCpt2",
          pid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.currentData = res.data.current;
          this.historicalData = res.data.historical;
        });
    },
    availableMeters(key) {
      let result = [];
      let meterNames = this.assignedMeters[key].map((meter) => meter.meter);
      this.currentMeters.forEach((meter) => {
        if (!meterNames.includes(meter.MeterID._text)) {
          result.push(meter);
        }
      });
      return result;
    },
    async getAddedMeters() {
      let content = {
        PatientCpt: {
          API_Meth: "GetMeterCpt",
          pid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status == "Success" && res.data.count != 0) {
            let results = res.data.result;
            results.forEach((m) => {
              this.assignedMeters[m.cpt].push(m);
            });
          } else if (res.data.status != "Success") {
            alert(res.data.status);
          }
        });
    },
    async addingNewMeter(key) {
      let meterInfo = this.addedMeter[key];
      if (meterInfo == 0) return;
      let key2 =
        key === "98980"
          ? "98981"
          : key === "98981"
          ? "98980"
          : key === "99457"
          ? "99458"
          : key === "99458"
          ? "99457"
          : "";
      let confirmMsg = "";
      if (key2 === "")
        confirmMsg = `Would you like to assign the meter ${meterInfo.MeterID._text} (${meterInfo.MeterName._cdata}) to CPT code ${key}?`;
      else
        confirmMsg = `Would you like to assign the meter ${meterInfo.MeterID._text} (${meterInfo.MeterName._cdata}) to CPT codes ${key} and ${key2}?`;

      if (confirm(confirmMsg)) {
        let content = {
          PatientCpt: {
            API_Meth: "AddMeterCpt",
            pid: this.allData.patient.externId,
            meter: meterInfo.MeterID._text,
            cpt: key,
            meterName: meterInfo.MeterName._cdata,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.status == "Success") {
              if (key2 != "") {
                content["PatientCpt"]["cpt"] = key2;
                axios
                  .post(CURR_API + "/tswebhook.php", content, {
                    headers: { "Content-Type": "application/json;" },
                  })
                  .then((res) => {
                    if (res.data.status == "Success") {
                      for (var el in this.assignedMeters) this.assignedMeters[el] = [];
                      this.getAddedMeters();
                    } else {
                      alert(res.data.status);
                    }
                  });
              } else {
                for (var el in this.assignedMeters) this.assignedMeters[el] = [];
                this.getAddedMeters();
              }
            } else {
              alert(res.data.status);
            }
          });
      }
    },
    async getDevices() {
      let content = {
        GetPatientInfo: {
          API_Meth: "GetPatientDevice",
          pid:
            ("" + this.allData.patient.externId).length == 7
              ? "0" + this.allData.patient.externId
              : "" + this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(
          (res) => {
            let xml = res.data.ReMsg;
            if (!xml) return;
            let json = xml2js(xml, { compact: true });
            let meters = json["QueryResult"]["ReData"]
              ? json["QueryResult"]["ReData"]["CaseMeterData"]["Meter"]
              : [];
            if (Array.isArray(meters)) {
              this.currentMeters = meters;
            } else if (typeof meters === "object") {
              this.currentMeters = [meters];
            }
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
$color-base: #0060ff;
.page {
  background-color: #fff;
  margin: 1.5rem auto;
  padding: 2rem;
  margin-bottom: 100px;
}

.row {
  flex-wrap: nowrap;
}

.container .top-col {
  background: #646dc5;
}

.device__header,
.list__header {
  font-size: 2.5rem;
  color: $color-base;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}

.columntop {
  width: 100%;
  /*80%;*/
  display: flex;
  flex-direction: row;
  max-width: 1320px;
  text-align: center;
  justify-content: center;
}

.columnrow {
  width: 100%;
  display: flex;
  flex-direction: row;
  max-width: 1320px;
  text-align: center;
  justify-content: center;
}

.columnbottom {
  width: 100%;
  /*80%;*/
  display: flex;
  flex-direction: row;
  max-width: 1500px;
  text-align: center;
  justify-content: center;
  background-color: #98bfe1;
  color: #ffffff;
}

.pagnav a {
  color: #ffffff;
  margin-left: 10px;
}

.columntop span {
  color: #fff;
}

.toptitle h1 {
  text-align: center;
  color: #ffffff;
  font-size: 22px;
}

.toptitle {
  background-color: #0060ff;
}

.searchfindarea .container {
  display: flex;
  flex-direction: row;
}

.gridarea {
  width: 100%;
  height: auto;
}

.top-row-device {
  border-right: 2px solid black;
}

.top-row-device:last-child {
  border-right: none;
}

// .columnrow:nth-child(even) .top-row-device {
//     background-color: #ffff;
// }
.columnrow:nth-child(4n) .top-row-device {
  background-color: #98bfe1;
}

.meterList {
  display: flex;
  flex-direction: column;
}

.meterListColumn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#meterOptions {
  margin-bottom: 5%;
}
</style>
